<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <con-page-header header="Imports"></con-page-header>
  <con-page-layout-content>
    <p>
      To prepare your student import
      <a href="../../../../assets/sample/ImportStudents.xlsx" download>download the import template</a>
      and follow the instructions on sheet 2. The current status of the import
      will be reported in the table below.
    </p>

    <div class="import-header" fxLayout="column" fxLayout.gt-sm="row">
      <mat-error *ngIf="fileTooLarge">Selected file exceeds the maximum file size of 3mb</mat-error>
      <div fxFlex></div>
      <button mat-mini-fab color="primary" *ngIf="isContributor" (click)="fileSelecter.click()">
        <mat-icon>assignment_return</mat-icon>
      </button>
      <input #fileSelecter type="file" [hidden]="true"
             accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
             (change)="fileSelected(fileSelecter.files)" />
    </div>

    <div class="matTable-container" *ngIf="media.isActive('lg') || media.isActive('xl')|| media.isActive('md')">
      <mat-table matSort #table [dataSource]="dataSource"
                 matSort class="mat-elevation-z8">
        <ng-container cdkColumnDef="filename">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header> Filename </mat-header-cell>
          <mat-cell *cdkCellDef="let row">{{ row.filename }}</mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="date">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header> Date </mat-header-cell>
          <mat-cell *cdkCellDef="let row">
            {{ row.timestamp | momentLocalizedDate : 'dateTime' }}
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="students_processed">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header> Students Processed </mat-header-cell>
          <mat-cell *cdkCellDef="let row">
            {{ row.students_processed }}
            <span *ngIf="row.students_processed !== undefined && row.students_count !== undefined">&nbsp;of&nbsp;</span>
            {{ row.students_count }}
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="status">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header> Status </mat-header-cell>
          <mat-cell *cdkCellDef="let row">{{ row.status }}</mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="report">
          <mat-header-cell *cdkHeaderCellDef> Report </mat-header-cell>
          <mat-cell *cdkCellDef="let row">
            <a (click)="viewImportErrors(row.id)">Report</a>
          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))">
      <ng-template ngFor let-import [ngForOf]="dataSource.data">
        <mat-list-item class="mobile-import-item">

          <div class="mobile-row">
            <div class="file-name">
              {{ import.filename }}
            </div>
            <div class="file-date">
              {{ import.timestamp | momentLocalizedDate : 'dateTime' }}
            </div>
          </div>

          <div class="mobile-subrow"
               *ngIf="import.students_processed && import.students_count">
            {{ import.students_processed }} of
            {{ import.students_count }} students
          </div>

          <div class="mobile-status">
            <div class="status-text">
              <a *ngIf="import.status === 'Errors'; else noError"
                 (click)="viewImportErrors(import.id)">
                {{ import.status }}
                <mat-icon class="icon-warning">warning</mat-icon>
              </a>
              <ng-template #noError>{{ import.status }}</ng-template>
            </div>

            <div class="report-link">
              <a (click)="viewImportErrors(import.id)">
                Report
              </a>
            </div>
          </div>

        </mat-list-item>
        <mat-divider></mat-divider>
      </ng-template>
    </mat-list>
  </con-page-layout-content>
</con-page-layout>
